import cn from 'classnames';

export const tableTitleFilterWrapperClassName = ({ filter }: { filter?: boolean }) =>
  cn(filter && 'cursor-pointer hover:bg-bg_4');
